// extracted by mini-css-extract-plugin
export default {"wrapper":"ResendPassword_wrapper__cRgRc","title":"ResendPassword_title__hdquY","text":"ResendPassword_text__ex4ak","button":"ResendPassword_button__TpN4o"};